import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import PartyTargetVsAchivementTable from './partTargetVsAchivementReportTable'
import { connect } from 'react-redux'
import { getPatyTargetAchivementReportFilterData, getPartyTargetAchivementReportData } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { headerColumnPartyTargetReport, headerFilterColumnPartyTargetReport } from '../common/reportConstants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
const formatTotalValue = (value) => Number(value || 0).toFixed(2)

const PartyTargetVsAchivement = (props) => {
    const { data: { common, reports }, getPatyTargetAchivementReportFilterData } = props
    const { loginData: reduxLoginData = {} } = common
    const [searchParams] = useSearchParams()
    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = searchParams.get('C') || 0
        loginData.intBranchCityID = searchParams.get('CT') || 0
        loginData.strCityName = searchParams.get('CTN') || 0
        loginData.intUserID = searchParams.get('U') || 0
        loginData.intBranchID = searchParams.get('B') || 0
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        loginData.IsBranchAdmin = searchParams.get('IBA') || 0
        loginData.IsMTPLAdmin = searchParams.get('IMPTLA') || 0
        loginData.IsAdmin = searchParams.get('IA') || 0
        isFromUrl = true
    }
    if (reduxLoginData && Object.keys(reduxLoginData).length > 0) {
        loginData = reduxLoginData
    }
    const { partyTargetAchivmentFilterData, partyTargetAchivmentReportData } = reports
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [showReport, setShowReport] = useState(false)
    const [filterCityList, setFilterCityList] = useState([]);
    const [filterPartyList, setFilterPartyList] = useState([]);
    const [filteredParties, setFilteredParties] = useState([]);
    const [partyCity, setPartyCity] = useState()
    const [party, setParty] = useState()
    const [tableData, setTableData] = useState([])
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    useEffect(() => {
        if (partyTargetAchivmentFilterData?.length > 0) {
            const cityMap = new Map();
            const partyMap = new Map();

            partyTargetAchivmentFilterData.forEach((item) => {
                // Add unique city details
                if (!cityMap.has(item.CityID)) {
                    cityMap.set(item.CityID, { CityName: item.CityName, CityID: item.CityID });
                }
                // Add unique party details
                if (!partyMap.has(item.PartyID)) {
                    partyMap.set(item.PartyID, { PartyName: item.PartyName, PartyID: item.PartyID, CityID: item.CityID });
                }
            });
            setFilterCityList([{CityID:0,CityName:'ALL'},...cityMap.values()]);
            setFilterPartyList([{PartyID:0,PartyName:'ALL'},...partyMap.values()]);
            setFilteredParties([...partyMap.values()])//for filterporpose
            setParty({PartyID:0,PartyName:'ALL'})
            setPartyCity({CityID:0,CityName:'ALL'})
        }
    }, [partyTargetAchivmentFilterData]);
    useEffect(() => {
        if (partyTargetAchivmentReportData?.length > 0) {
            let data = partyTargetAchivmentReportData.map((item, index) => ({
                ...item,
                SN: index + 1,
                targetType: 'Amount',
                TargetStartDate: item?.TargetStartDate === '' ? '' : moment(item.TargetStartDate).format('DD MMM YYYY'),
                TargetEndDate: item?.TargetEndDate === '' ? '' : moment(item.TargetEndDate).format('DD MMM YYYY'),
            }));
    
            // Calculate totals
            const totals = data.reduce(
                (acc, item) => {
                    acc.TargetAmount += item.TargetAmount || 0;
                    acc.TargetProgress += parseFloat(item.TargetProgress) || 0;
                    acc.TotalLRs += item.TotalLRs || 0;
                    acc.TotalItems += item.TotalItems || 0;
                    acc.TotalNetAmounts += item.TotalNetAmounts || 0;
                    return acc;
                },
                {
                    TargetAmount: 0,
                    TargetProgress: 0,
                    TotalLRs: 0,
                    TotalItems: 0,
                    TotalNetAmounts: 0,
                }
            );
            const totalRow = {
                isTotal: true,
                SN: 'Total',
                TargetAmount: formatTotalValue(totals.TargetAmount),
                TargetProgress: formatTotalValue(totals.TargetProgress),
                TotalLRs: formatTotalValue(totals.TotalLRs),
                TotalItems: formatTotalValue(totals.TotalItems),
                TotalNetAmounts: formatTotalValue(totals.TotalNetAmounts),
            };
            data.push(totalRow);
    
            setTableData(data);
        } else {
            setTableData([]);
        }
    }, [partyTargetAchivmentReportData]);
    
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    // const generateReport = () => {
    //     setShowReport(true)
    //     if (partyCity == '' || partyCity == ' ') {
    //         updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    //     } else if (party == "" || party == ' ') {
    //         updateAlertError({ show: true, msg: 'Select Party Name', nextId: '' })
    //     } else {
    //         const obj = {
    //             CompanyID: loginData?.intCompanyID,
    //             CityID: partyCity?.CityID,
    //             PartyID: party?.PartyID,
    //             dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
    //             dtToDate: moment(toDate).format('YYYY-MM-DD'),
    //         }
    //         getPartyTargetAchivementReportData(obj)
    //     }
    // }
    const filterData = {
      fromDate: moment(fromDate).format('DD-MMM-YYYY'),
      toDate: moment(toDate).format('DD-MMM-YYYY'),
      comapny: loginData?.strCompanyName,
      partyCity: partyCity?.CityName,
      partyName: party?.PartyName,
      dataType: 'entry',
    }
        const generateReport = (isPdf = false) => {
          if (!partyCity || partyCity === '' || partyCity === ' ') {
            setAlert({ show: true, msg: 'Select City', nextId: '' })
            return
          } else if (!party || party === '' || party === ' ') {
            setAlert({ show: true, msg: 'Select Party Name', nextId: '' })
            return
          }
          setLoader(true)
          const obj = {
            CompanyID: loginData?.intCompanyID,
            CityID: partyCity?.CityID,
            PartyID: party?.PartyID,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
          }
          GetRequest(urls.getPartyTargetAchivementReportData, obj)
            .then((res) => {
              if (res.status !== 'Success') {
                throw new Error(res?.ErrMessage || 'Request Failed')
              }
              if (!Array.isArray(res?.Data?.Table) || res?.Data?.Table.length === 0) {
                throw new Error('No Data Found')
              }
              let updatedData = res?.Data?.Table.map((item, index) => ({
                ...item,
                SN: index + 1,
                dataType: 'entry',
                targetType:'Amount',
                textColor: { status: item.status === 'Active' ? 'green' : 'red' },
                TargetStartDate: moment(item.TargetStartDate).format('DD MMM YYYY'),
                TargetEndDate: moment(item.TargetEndDate).format('DD MMM YYYY'),
              }))
              const totals = updatedData.reduce(
                (acc, item) => {
                  acc.TargetAmount += item.TargetAmount || 0
                  acc.TargetProgress += parseFloat(item.TargetProgress) || 0
                  acc.TotalLRs += item.TotalLRs || 0
                  acc.TotalItems += item.TotalItems || 0
                  acc.TotalNetAmounts += item.TotalNetAmounts || 0
                  return acc
                },
                {
                  TargetAmount: 0,
                  TargetProgress: 0,
                  TotalLRs: 0,
                  TotalItems: 0,
                  TotalNetAmounts: 0,
                }
              )
              const totalRow = {
                isTotal: true,
                targetType: 'Total',
                align:'right',
                TargetAmount: formatTotalValue(totals.TargetAmount),
                TargetProgress: formatTotalValue(totals.TargetProgress),
                TotalLRs: formatTotalValue(totals.TotalLRs),
                TotalItems: formatTotalValue(totals.TotalItems),
                TotalNetAmounts: formatTotalValue(totals.TotalNetAmounts),
                dataType: 'total',
              }
              updatedData.push(totalRow)
              const reportPayload = {
                reportName,
                criteriaHeaders: headerFilterColumnPartyTargetReport,
                criteriaData: [filterData],
                tableData: updatedData,
                mainHeader: headerColumnPartyTargetReport,
                isShowManageColumn: false,
                manageColumnID: '',
                hideHeader: false,
              }
              if (isPdf) {
                downloadPDF({
                  reportName,
                  criteriaHeaders: headerFilterColumnPartyTargetReport,
                  criteriaData: [filterData],
                  tableData: updatedData,
                  visibleColumns: headerColumnPartyTargetReport,
                  loginData,
                  hideHeader: false,
                })
                return
              }
              const rid = Date.now().toString()
              if (!window.generatedReports) {
                window.generatedReports = {}
              }
              window.generatedReports[rid] = reportPayload
              window.open(`/view-report?rid=${rid}`, '_blank')
            })
            .catch((err) => {
              setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => setLoader(false))
        }
    const handleGoClick = () => {
        // if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
        //     updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        // } else {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            PartyID: 0,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
        }
        getPatyTargetAchivementReportFilterData(obj)
        // }
    }
    const selectedPartyCity = (obj) => {
        setShowReport(false);
        setPartyCity(obj);
        // Filter the party list based on selected city
        const filtered = filteredParties.filter((val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val?.CityID === 0 || obj.CityID === 0);
        setFilterPartyList([{PartyID:0,PartyName:'ALL'},...filtered]);
        setParty({PartyID:0,PartyName:'ALL'})
        // Set the first party of the selected city as the default selected party
        // if (filtered.length > 0) {
        //     setParty(filtered[0]);
        // }
    };
    const reportName = 'Party Business Report'
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {!isFromUrl && <ReportHeading reportName={reportName} />}
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    {!isFromUrl && <><Item sx={sx.itemsx}>
                        <DropDownOA
                            // id={id.selectCompnay}
                            label={"Select Company"}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => setSelCompany(val)}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item></>}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Booking Date`}
                            name={'from_date'}
                            value={fromDate}
                            id={'fromDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? {...sx.itemsxGrow, width: '60%'} : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Booking Date'}
                            name={'to_date'}
                            value={toDate}
                            id={'toDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goButtonDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            id={'goButtonDate'}
                            onClick={handleGoClick}
                            onKeyDown={(e) => { navigation3(e, 'selectedCity', 'toDate', () => handleGoClick()) }}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select Party City`}
                            id={'selectedCity'}
                            data={filterCityList || []}
                            // disabled={disableBtn}
                            defaultvalue={partyCity?.CityName || partyCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedPartyCity(obj) }}
                            // onSelect={(val) => { setShowReport(false); setPartyCity(val) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Party Name'}
                            data={filterPartyList || []}
                            defaultvalue={party?.PartyName || party}
                            dataKey={`PartyName`}
                            idKey={`PartyID`}
                            // onSelect={(val) => { selectedSourceBranch(val) }}
                            onSelect={(val) => { setShowReport(false); setParty(val) }}
                            nextId={'generateButton'}
                            prevId={'selectedCity'}
                            width="100%"
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom: '10px' }} className="btn btn-primary" onClick={() => generateReport(true)} id={'generateButton'}>
                            DOWNLOAD PDF
                        </Button> :
                    <Item sx={sx.itemsx}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={'generateButton'}
                            onClick1={()=>generateReport(false)}
                        // onClick2={handleClick2}
                        />
                    </Item>}
                </Box>
            </Item>
            {
                showReport ? <PartyTargetVsAchivementTable tableData={tableData} loginData={loginData} partyCity={partyCity} party={party} fromDate={fromDate} toDate={toDate} /> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getPatyTargetAchivementReportFilterData, getPartyTargetAchivementReportData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(PartyTargetVsAchivement)
